
<template>
  <div id="app"><router-view /></div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.isMobile();
  },
  methods: {
    //判断是移动端还是PC端
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) {
        console.log('移动端打开');
        // window.location.href = 'http://web.egouhome.cn/'
      } else {
        console.log('PC端打开');
      }
    },

    //跳转到新闻资讯
    linkNew() {
      this.$router.push({ path: '/messageIndex', query: {} });
    },

  }
};
</script>
<style>
/* #app {font-family:Microsoft YaHei;-webkit-font-smoothing: antialiased;-moz-osx-font-smoothing: grayscale;color: #343434; } */
body, h1, h2, h3, h4, h5, h6, hr, p, blockquote, dl, dt, dd, ul, ol, li, pre, form, fieldset, legend, button, input, textarea, th, td { margin: 0; padding: 0; }
body, button, input, select, textarea {  font-family: "Helvetica Neue", Helvetica, Arial, 微软雅黑;
    font-size: 14px;
    line-height: 1.42857;
    color: rgb(51, 51, 51);}
h1, h2, h3, h4, h5, h6 { font-size: 100%; }
ul, ol ,li{ list-style: none; }
img {margin:0; border:0; padding:0;}
b {font-family:Tahoma; font-weight:300; }
a { text-decoration:none; color:#000; }
a:hover { text-decoration:none;  }
.clear { clear: both;}
input:focus,select:focus { outline:none;}
body{ width: 100%;}

.css_style{
	transition: all 0.3s ease-out 0s;
	-webkit-transition: all 0.3s ease-out 0s;
	-moz-transition: all 0.3s ease-out 0s;
	-o-transition: all 0.3s ease-out 0s;}
.fl{ float: left!important;}
.fr{ float: right!important;}

.title {
	margin: 100px auto 40px;
	text-align: center;
	font-size: 20px;
	line-height: 40px;
	color: #3c3b3b;
	font-family: Font_Light;
}
.title_2{
	margin: 40px auto;
    text-align: center;
    font-size: 40px;
    line-height: 40px;
    color: #2e2e2e;
    font-family: Font_Normal;
}
.title_3{
	margin: 20px auto 40px;
    text-align: center;
    font-size: 24px;
    color: #2e2e2e;
    font-family: Font_Normal;
}
.hr_1{
	margin-top: 20px;
    margin-bottom: 25px;
    border: 0;
    border-top: 1px solid #000000;
}
.mt0{ margin-top: 0px !important;}
.mt10{ margin-top: 10px !important;}
.mt20{ margin-top: 20px !important;}
.mt30{ margin-top: 30px !important;}
.mt40{ margin-top: 40px !important;}
.mt50{ margin-top: 50px !important;}

.mb20{ margin-bottom: 20px !important;}
.mb30{ margin-bottom: 30px !important;}
.mb40{ margin-bottom: 40px !important;}
.mb80{ margin-bottom: 80px !important;}

.pa30{ padding: 30px !important;}

.lineh30{ line-height: 30px !important;}

.txt_in{
	text-indent: 2em;
}
.ellipsis-one{display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;overflow: hidden;}
.ellipsis-two{display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;}
</style>



// WEBPACK FOOTER //
// src/App.vue